<template>
  <v-card class="mx-auto mb-10">
    <v-card-title class="font-weight-bold">
        Off Air
    </v-card-title>
    <v-divider />
    <div class="skeleton-list-item w-full" v-if="hourlyReportLoading">
        <v-skeleton-loader  :loading="true" type="image"></v-skeleton-loader>
    </div>
    <v-simple-table class="pa-4 mt-2" v-if="!hourlyReportLoading">
      <template v-slot:default>
        <tbody class="simple-table-borders">
            <tr class="accent lighten-4">
                <td rowspan="2" class="text-center border-right border-left">Once</td>
                <td class="text-right border-right font-weight-bold">No. of donations added to the tally</td>
                <td class="px-15 text-center border-right">
                    {{OffAirSummary && OffAirSummary.once_count ? OffAirSummary.once_count : 0}}
                </td>
            </tr>
            <tr class="accent lighten-4">
                <td class="text-right border-right font-weight-bold">$ value of donations added to the tally</td>
                <td class="px-15 text-center border-right">
                    {{OffAirSummary && OffAirSummary.once_amount ? OffAirSummary.once_amount : 0}}
                </td>
            </tr>
            <tr style="height: 30px"></tr>
            <tr class="accent lighten-4">
                <td rowspan="2" class="text-center border-top border-right border-left">Recurring</td>
                <td class="text-right border-right border-top border-top font-weight-bold">No. of donations added to the tally</td>
                <td class="px-15 text-center border-right border-top">
                    {{OffAirSummary && OffAirSummary.rec_count ? OffAirSummary.rec_count : 0}}
                </td>
            </tr>
            <tr class="accent lighten-4">
                <td class="text-right border-right font-weight-bold">$ value of donations received</td>
                <td class="px-15 text-center border-right">
                    {{OffAirSummary && OffAirSummary.rec_amount ? OffAirSummary.rec_amount : 0}}
                </td>
            </tr>
            <tr style="height: 30px"></tr>
            <tr>
                <td class="border-none"></td>
                <td class="text-right border-right font-weight-bold border-none">No of new Donors</td>
                <td class="px-15 text-center border-right border-none">
                    {{OffAirSummary && OffAirSummary.new_donors ? OffAirSummary.new_donors : 0}}
                </td>
            </tr>
            <tr>
                <td class="border-none"></td>
                <td class="text-right border-right font-weight-bold border-none">No of Incentive Donations</td>
                <td class="px-15 text-center border-right border-none">
                    {{OffAirSummary && OffAirSummary.incentive_donation ? OffAirSummary.incentive_donation : 0}}
                </td>
            </tr>
            <tr>
                <td class="border-none"></td>
                <td class="text-right border-right font-weight-bold border-none">No of Incentives</td>
                <td class="px-15 text-center border-right border-none">
                    {{OffAirSummary && OffAirSummary.incentive_count ? OffAirSummary.incentive_count : 0}}
                </td>
            </tr>
            <tr>
                <td class="border-none"></td>
                <td class="text-right border-right font-weight-bold border-none">No. of donations added the inspiration fund</td>
                <td class="px-15 text-center border-right border-none">
                    {{OffAirSummary && OffAirSummary.inspiration_count ? OffAirSummary.inspiration_count : 0}}
                </td>
            </tr>
            <tr>
                <td class="border-none"></td>
                <td class="text-right border-right font-weight-bold border-none">$ value of donations added to the inspiration fund</td>
                <td class="px-15 text-center border-right border-none">
                    {{OffAirSummary && OffAirSummary.inspiration_amount ? OffAirSummary.inspiration_amount : 0}}
                </td>
            </tr>
            <tr>
                <td class="border-none"></td>
                <td class="text-right border-right font-weight-bold border-none">Total no. of donations</td>
                <td class="px-15 text-center border-right border-none">
                    {{OffAirSummary && OffAirSummary.donation_count ? OffAirSummary.donation_count : 0}}
                </td>
            </tr>
            <tr>
                <td class="border-none"></td>
                <td class="text-right border-right font-weight-bold border-none">$ Total value of donations</td>
                <td class="px-15 text-center border-right border-none">
                    {{OffAirSummary && OffAirSummary.donation_amount ? OffAirSummary.donation_amount : 0}}
                </td>
            </tr>
        </tbody>
      </template>
    </v-simple-table> 
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['hourlyReportLoading', 'OffAirSummary'])
  }
}
</script>
